<div class="support-documentation__category-card-grid">
  <sbnb-category-card *ngFor="let category of categories" [category]="category"></sbnb-category-card>
</div>
